App.prototype.infiniteScrollCategories = function () {
    if ($('.category-page').length) {
        const productsContainers = {};
        const elContainers = document.querySelectorAll('.product-list-wrapper .products-holder, .product-list-wrapper, .product-wrapper .products-holder');

        if(elContainers){
            for (const elContainer of elContainers) {
                productsContainers[elContainer.dataset.categoryUniqueId] = elContainer;
            }
        }

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    if (entry.target.classList.contains('load-more-trigger')) {
                        let page = entry.target.dataset.page ? entry.target.dataset.page : 1;
                        loadMoreProducts(page, null, entry.target.dataset.categoryUniqueId);
                        entry.target.dataset.page = (parseInt(page) + 1).toString();
                    } else if (entry.target.classList.contains('infinite-page') && entry.target.classList.contains('unloaded')) {

                        console.info('intersecting ' + entry.target.dataset.page);
                        entry.target.classList.remove('unloaded');

                        loadMoreProducts(parseInt(entry.target.dataset.page), entry.target, entry.target.dataset.categoryUniqueId);
                    }
                } else if (entry.target.classList.contains('infinite-page') && !entry.target.classList.contains('unloaded')) {
                    entry.target.classList.add('unloaded');
                    entry.target.innerHTML = "";
                }
            });
        }, {
            rootMargin: '200px',
            threshold: 0
        });

        const loadMoreTriggers = document.querySelectorAll('.load-more-trigger');

        if (loadMoreTriggers){
            for (const loadMoreTrigger of loadMoreTriggers) {
                observer.observe(loadMoreTrigger);
            }
        }

        function loadMoreProducts(page, pageContainer = null, category_unique_id) {
            const urlParams = new URLSearchParams(location.search);
            let queryString = '';
            if (urlParams.toString()){
                queryString = `&${urlParams.toString()}`;
            }
            fetch(`/api/products/category/${category_unique_id}?page=${page}${queryString}`)
                .then(response => response.json())
                .then(items => {
                    const elLoadMoreTrigger = document.querySelector(`.load-more-trigger[data-category-unique-id="${category_unique_id}"]`);
                    if (items.is_last_page) {
                        elLoadMoreTrigger.style.setProperty("display", "none", "important")
                    }else{
                        elLoadMoreTrigger.style.display = 'block';
                    }

                    if (items.data.length){
                        let is_already_being_observed = true;

                        if (!pageContainer){
                            pageContainer = document.createElement('div');
                            pageContainer.classList.add('row', 'page-' + page, 'infinite-page');
                            pageContainer.dataset.categoryUniqueId = category_unique_id;
                            if (productsContainers[category_unique_id].dataset.infiniteRowClasses) {
                                pageContainer.classList.add(...productsContainers[category_unique_id].dataset.infiniteRowClasses.split(' '));
                            }
                            pageContainer.dataset.page = page;
                            is_already_being_observed = false;
                        }

                        for (const item of items.data) {
                            pageContainer.innerHTML += item;
                        }

                        if (!is_already_being_observed){

                            productsContainers[category_unique_id].appendChild(pageContainer);

                            const elPage = productsContainers[category_unique_id].querySelector('.page-'+page);

                            elPage.style.height = elPage.clientHeight + 'px';

                            while (elPage.clientHeight === 0){
                                elPage.style.height = 'auto';
                                elPage.style.height = elPage.clientHeight + 'px';
                            }

                            observer.observe(productsContainers[category_unique_id].querySelector('.page-'+page));
                        }
                    }

                })
                .catch(error => console.error('Error loading more products:', error));
        }
    }
}

App.prototype.infiniteScrollCategories();
